export enum PathItemInfoTooltipContext {
  PATH_BAR,
  PATH_DESIGN
}
